if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (!this.form) {
          console.error('ProductForm: Form element not found.');
          return;
        }

        // Ensure variantIdInput exists before trying to access its properties
        if (this.variantIdInput) {
          this.variantIdInput.disabled = false;
        }

        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (this.submitButton) {
          this.submitButtonText = this.submitButton.querySelector('span');
          // Set aria-haspopup if a cart-drawer exists
          if (document.querySelector('cart-drawer')) {
            this.submitButton.setAttribute('aria-haspopup', 'dialog');
          }
        } else {
          console.warn('ProductForm: Submit button not found.');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
        this.error = false; // Initialize error state
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        /* --- Mobile quick exit: rely on hidden return_to=/cart --- */
        if (window.innerWidth <= 768) {
          this.form.submit();                                           // normal POST → /cart
          return;
        }
        if (this.submitButton?.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage(); // Clear previous error messages
        this.error = false; // Reset error state for this submission

        if (this.submitButton) {
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.classList.add('loading');
        }
        const loadingSpinner = this.querySelector('.loading__spinner');
        if (loadingSpinner) {
          loadingSpinner.classList.remove('hidden');
        }

        const config = fetchConfig('javascript'); // Assuming fetchConfig is a global helper
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        // Sending sections for cart drawer/notification update is not strictly necessary if always redirecting,
        // but leaving it in doesn't harm and might be used by other listeners before the redirect.
        if (this.cart && typeof this.cart.getSectionsToRender === 'function') {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          if (typeof this.cart.setActiveElement === 'function') {
            this.cart.setActiveElement(document.activeElement);
          }
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config) // Assuming routes is a global object
          .then((response) => response.json())
          .then((response) => {
            if (response.status) { // Handle error from Shopify AJAX API
              // Assuming PUB_SUB_EVENTS and publish are global/imported
              if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  errors: response.errors || response.description,
                  message: response.message,
                });
              }
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton ? this.submitButton.querySelector('.sold-out-message') : null;
              if (soldOutMessage && this.submitButton) {
                this.submitButton.setAttribute('aria-disabled', true);
                if (this.submitButtonText) this.submitButtonText.classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
              }
              this.error = true;
              return; // Stop further processing on error
            }

            // ---- SUCCESSFUL ADD TO CART ----
            // ALWAYS REDIRECT TO THE CART PAGE
            // Assuming window.Shopify.routes.root and window.Shopify.routes.cart_url are available
            const cartUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.cart_url)
                            ? window.Shopify.routes.cart_url
                            : '/cart'; // Fallback
            window.location.href = cartUrl;
            return; // IMPORTANT: Stop further execution in this .then() block.
          })
          .catch((e) => {
            console.error('ProductForm AJAX Error:', e);
            // Provide user feedback for generic fetch errors
            const genericErrorMessage = (window.Shopify && window.Shopify.theme && window.Shopify.theme.strings && window.Shopify.theme.strings.cartError)
                                        ? window.Shopify.theme.strings.cartError
                                        : 'An error occurred. Please try again.';
            this.handleErrorMessage(genericErrorMessage);
            this.error = true; // Set error flag for finally block
          })
          .finally(() => {
            if (this.submitButton) {
              this.submitButton.classList.remove('loading');
              // Only re-enable the button if there wasn't an error that should keep it disabled
              if (!this.error) {
                this.submitButton.removeAttribute('aria-disabled');
              }
            }
            if (loadingSpinner) {
              loadingSpinner.classList.add('hidden');
            }

            // Assuming CartPerformance is a global object and its methods exist
            // If CartPerformance isn't defined or measureFromEvent isn't a function, this might error.
            // Consider adding checks if CartPerformance might not always be available.
            // if (typeof CartPerformance !== 'undefined' && typeof CartPerformance.measureFromEvent === 'function') {
            //   CartPerformance.measureFromEvent("add:user-action", evt);
            // }
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        if (!this.errorMessage) return; // Ensure errorMessage element also exists

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      // This method might not be actively used if the button state is handled directly
      // in onSubmitHandler and finally, but keeping it for potential other uses.
      toggleSubmitButton(disable = true, text) {
        if (!this.submitButton) return;

        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text && this.submitButtonText) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          if (this.submitButtonText && window.variantStrings && window.variantStrings.addToCart) {
             // Assuming window.variantStrings.addToCart is globally available
            this.submitButtonText.textContent = window.variantStrings.addToCart;
          }
        }
      }

      get variantIdInput() {
        // Check if this.form exists before querying within it
        return this.form ? this.form.querySelector('[name=id]') : null;
      }
    }
  );
}